import Resizer from "react-image-file-resizer";

export const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      1200,
      1200,
      "JPEG",
      70,
      0,
      (uri) => {
        resolve(uri);
      },
      // "base64"
      "file"
    );
  });